import _inheritsLoose from "@babel/runtime-corejs3/helpers/inheritsLoose";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js/instance/concat";
import { Component, inject } from 'intact-vue-next';
import template from './menu.vdt';
import { SELECT } from './constants';
import { useCard } from './useCard';
import { useSearchable } from './useSearchable';
import { useConfigContext } from '../config';
export var SelectMenu = /*#__PURE__*/function (_Component) {
  _inheritsLoose(SelectMenu, _Component);
  function SelectMenu() {
    var _context;
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, _concatInstanceProperty(_context = [this]).call(_context, args)) || this;
    _this.select = inject(SELECT);
    _this.card = useCard(_this.select.label.activeIndices);
    _this.searchable = useSearchable();
    _this.config = useConfigContext();
    return _this;
  }
  return SelectMenu;
}(Component);
SelectMenu.template = template;